<template>
<div>
  <div v-if="referral && referral.userId">
    <heading>Jobseeker</heading>
    <user-row-card class="hoverable" :user="user" @click="onUserClicked" />
    <divider />
  </div>
  <heading>Referred</heading>
  <span v-if="referral">{{ referralDate }}</span>
  <divider />
  <heading>Status</heading>
  <span v-if="referral">{{ status }}</span>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import UserRowCard from '@/components/general/user-row-card'
import Divider from '@/components/general/divider'
import Heading from '@/components/general/heading'
import moment from 'moment'
import _ from 'lodash'

export default {
  components: {
    UserRowCard, Divider, Heading
  },
  props: {
    referral: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    user () {
      return {
        id: this.referral.userId,
        firstName: this.referral.userFirstName,
        lastName: this.referral.userLastName,
        profilePictureUrl: this.referral.userProfilePictureUrl,
        role: this.referral.userRole,
        location: this.referral.userLocation,
        companyName: this.referral.userCompanyName
      }
    },
    ...mapGetters('referrals', [
      'referralStatus'
    ]),
    referralDate () {
      return moment(this.referral.createdAt).format('DD MMM YY, hh:mm A')
    },
    status () {
      return _.capitalize(this.referralStatus(this.referral))
    }
  },
  methods: {
    onUserClicked () {
      const jobseekerId = this.referral.userId
      window.open(`/jobseekers/${jobseekerId}`, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/defaults.scss';

.hoverable:hover {
  cursor: pointer;
  background-color: $hover-background;
}
</style>



// WEBPACK FOOTER //
// src/components/referrals/referral-details.vue